import { CONTINENT_LOCATION_LIST, CONTINENT_LOCATIONS } from '../constants'
import { getFirstMatchingStringFromAnotherArray } from '../../../utils/getFirstMatchingStringFromAnotherArray'
import locationListIncludesUnitedKingdom from './locationListIncludesUnitedKingdom'
import { isNonEmptyArray } from '../../../utils/checks'

interface GetCountryOrContinentFromLocationList {
  (locationsList: string[], contryList: string[]): string
}

export const getCountryOrContinentFromLocationList: GetCountryOrContinentFromLocationList =
  (locationsList, contryList) => {
    if (!isNonEmptyArray(locationsList)) {
      return ''
    }

    const includesUnitedKingdom =
      locationListIncludesUnitedKingdom(locationsList)

    if (includesUnitedKingdom) {
      return CONTINENT_LOCATIONS.EUROPE
    }

    const matchingCountry = getFirstMatchingStringFromAnotherArray({
      arrayToMatch: locationsList,
      targetArray: contryList
    })

    if (matchingCountry) {
      return matchingCountry
    }

    return getFirstMatchingStringFromAnotherArray({
      arrayToMatch: locationsList,
      targetArray: CONTINENT_LOCATION_LIST
    })
  }
